export default "__VITE_ASSET__d664955b__"